<template>
  <v-layout row justify-center style="position: relative;">
    <v-dialog :value="show" width="400" @input="$emit('close', $event)">
      <v-card>
        <v-card-title class="text-xs-center">
          <span class="headline">
            Advertencia!
          </span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <span>
            ¿Estas seguro que deseas eliminar {{text}}?
          </span> 
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red--text darken-1" flat="flat" @click="$emit('close', false)">Cancelar</v-btn>
          <v-btn class="red--text darken-1" flat="flat" @click="deleteItem(id)">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    deleteItem(id) {
      this.axios.delete(`/${this.url}/${id}`).then(() => {
        this.$emit('deleted', id);
        this.$emit('close', false);
      }).catch((error) => {
        this.$emit('error', error.response.data);
      });
    },
  },
};
</script>

<style scoped>
.center{
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/global/DeleteDialogV2.vue